import {
  Box,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLoading } from "../../../../providers/loadingProvider";
import {
  institutionApplicantsSelector,
  institutionSelector,
  programsSelector,
  setInstitutionApplicants,
} from "../../../../store/researchauthoritiesSlice";
import { useQuery } from "../../../customHooks";
import ResearchesTable from "../../Components/applicants/researchers/ResearchesTable";
import {
  StyledTab,
  StyledTabs,
  TabPanel,
} from "../../Components/SecondaryTabs";
import { applicantEligibilityStatus } from "../../Constants";
import service from "../../Helpers/gifservices";

const PAGE_TITLE = "Researchers";
const DETAILS = `Dear colleagues,

This screen allows you to view researchers awaiting approval, as well as those you have approved or declined.
`;

const useStyles = makeStyles((theme) => ({
  infoIcon: {
    marginLeft: 5,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  tabs: {
    margin: 5,
    marginTop: 10,
  },
  formControl: {
    minWidth: "20%",
  },
}));

export default function Researchers() {
  const classes = useStyles();
  const loading = useLoading();
  const query = useQuery();
  const dispatch = useDispatch();
  const institution = useSelector(institutionSelector);
  const institutionApplicants = useSelector(institutionApplicantsSelector);
  const [program, setProgram] = useState(``);
  const [selectedTab, setSelectedTab] = useState(0);
  const [getFromUrl, setGetFromUrl] = useState(false);
  const [researchForApproval, setResearchForApproval] = useState([]);
  const [approvedResearches, setApprovedResearches] = useState([]);
  const [declinedResearches, setDeclinedResearches] = useState([]);
  const programTypes = useSelector(programsSelector);

  const updateApplicantNote = async (applicantId, note) => {
    const loadingId = loading.addLoading("Updating Note");
    await service.UpdateApplicantRAnote({ applicantId, note });
    getApplicants();
    loading.removeLoading(loadingId);
  };

  useEffect(() => {
    if (getFromUrl) return;
    const tab = query.get("tab");
    const program = query.get("program");
    if (program !== null && tab !== null) {
      debugger;
      setProgram(parseInt(program));
      setSelectedTab(parseInt(tab));
      setGetFromUrl(true);
    } else if (programTypes !== null) {
      if (programTypes[0].number) {
        const pnum = programTypes[0].number;
        console.log(pnum);
        setProgram(parseInt(pnum));
      }
    }
  }, [query, getFromUrl, programTypes]);

  const createPDF = async (proposalId, proposalNumber) => {
    if (!Boolean(proposalId)) return;
    const loadingId = loading.addLoading("Downloading Proposal Info");
    const pdfPath = await service.createProposalPDF({ proposalId });
    await service.downloadRawFile({
      path: pdfPath,
      filename: proposalNumber,
    });
    loading.removeLoading(loadingId);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const programChanged = (e) => {
    if (e.target.value) setProgram(e.target.value);
  };

  const getApplicants = useCallback(async () => {
    const loadingId = loading.addLoading("Loading Researchers");
    const applicantsIds = institutionApplicants
      .filter((a) => a.programTypeNumber === program)
      .map((a) => a.applicantId);
    var applicants = await service.GetApplicants({ applicantsIds });
    console.log("getApplicants", {
      program,
      l: institutionApplicants.length,
      app: applicants.length,
    });
    const applicantsForApproval = applicants.filter(
      (ap) =>
        ap.applicantStatus === applicantEligibilityStatus.waitingForApproval ||
        ap.applicantStatus === applicantEligibilityStatus.notEligible ||
        ap.applicantStatus === applicantEligibilityStatus.ChangeDecision
    );
    const approvedApplicants = applicants.filter(
      (ap) => ap.applicantStatus === applicantEligibilityStatus.approvedByRA
    );
    const declinedApplicants = applicants.filter(
      (ap) => ap.applicantStatus === applicantEligibilityStatus.declinedByRA
    );
    setResearchForApproval(applicantsForApproval);
    setApprovedResearches(approvedApplicants);
    setDeclinedResearches(declinedApplicants);
    loading.removeLoading(loadingId);
  }, [institutionApplicants, loading, program]);

  const updateApplicantStatus = async (applicantId, status) => {
    const loadingId = loading.addLoading("Updating");
    await service.UpdateAplicantStatus({ applicantId, status });
    loading.removeLoading(loadingId);
    getApplicants();
    refreshInstitutionApplicants();
  };

  const refreshInstitutionApplicants = () => {
    const institutionId = institution?.id;
    if (institutionId === null || institutionId === undefined) return;
    service
      .GetInstitutionApplicants({ institutionId })
      .then((institutionApplicants) => {
        dispatch(setInstitutionApplicants(institutionApplicants));
      });
  };

  useEffect(() => {
    getApplicants();
  }, [getApplicants]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box className={classes.header}>
          <Typography variant="subtitle2">{PAGE_TITLE}</Typography>
          <InfoOutlinedIcon className={classes.infoIcon} color="primary" />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <pre style={{ fontFamily: "inherit" }}>{DETAILS}</pre>
      </Grid>
      <Grid item xs={12}>
        <FormControl className={classes.formControl}>
          <InputLabel>Program</InputLabel>
          <Select value={program} onChange={programChanged} label="Program">
            {programTypes.map((a) => (
              <MenuItem key={a.number} value={a.number}>
                {a.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledTabs
          value={selectedTab}
          className={classes.tabs}
          onChange={handleTabChange}
          variant="fullWidth"
          aria-label="simple tabs example"
        >
          <StyledTab label="Researchers for approval" />
          <StyledTab label="Approved researches" />
          <StyledTab label="Declined researches" />
        </StyledTabs>
        <Divider style={{ marginTop: -6 }} />
        <TabPanel value={selectedTab} index={0}>
          <ResearchesTable
            updateResearcherNote={updateApplicantNote}
            createPDF={createPDF}
            researchers={researchForApproval}
            updateApplicantStatus={updateApplicantStatus}
          />
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <ResearchesTable
            updateResearcherNote={updateApplicantNote}
            createPDF={createPDF}
            researchers={approvedResearches}
            tableType="approved"
            updateApplicantStatus={updateApplicantStatus}
          />
        </TabPanel>
        <TabPanel value={selectedTab} index={2}>
          <ResearchesTable
            updateResearcherNote={updateApplicantNote}
            createPDF={createPDF}
            researchers={declinedResearches}
            tableType="decline"
            updateApplicantStatus={updateApplicantStatus}
          />
        </TabPanel>
      </Grid>
    </Grid>
  );
}
